import * as angular from "angular";
import {IController} from "angular";

export class BillingAccountLinkCtrl implements IController {

  id: string;
  name: string;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes) {
  }

}

angular
.module('bringoz.admin.billing-accounts')
.component('billingAccountLink', {
  bindings: {
    id: '<',
    name: '<'
  },
  template: require('./billing-account-link.html').default,
  controller: BillingAccountLinkCtrl
});
